import React, { Component } from 'react';
import history from '../history';
import Spinner from '../components/Spinner';
import Menu from '../components/Menu';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Form from '../components/EditForm';
import { $ } from 'jquery';
import { formData } from '../common';
import queryString from 'query-string';

export default class Grid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            label: "Users",
            sublabel: "Users",
            breadcrumbs: [{ label: "User Management", href: "/users" }, { label: "User Management", href: "/users" }],
            endpoint: "users/",
            pageLinks: [{ label: "Manage Users", link: "/users" }],
            columns:[
                {label:"First Name",name:"first_name",required:true,type:"text"},
                {label:"Last Name",name:"last_name",required:true,type:"text"},
                {label:"Username",name:"username",required:false,type:"text"},
                {label:"Email",name:"email",required:false,type:"text"},
                {label:"Groups ",name:"groups",required:false,type:"select",data:[{label:"Admin",value:1},{label:"Client",value:2}]},
                {label:"Gender ",name:"gender",required:false,type:"select",data:[{label:"Male",value:1},{label:"Female",value:2}]},
                {label:"Picture",name:"profile_picture",required:false,type:"file"},
                {label:"Address",name:"address",required:false,type:"text"},
                {label:"City",name:"city",required:false,type:"text"},
                {label:"State",name:"state",required:false,type:"text"},
                {label:"Zip Code",name:"zip",required:false,type:"text"},
                {label:"Country",name:"country",required:false,type:"text"},
                {label:"Status ",name:"is_active",required:false,type:"select",data:[{label:"Active",value:true},{label:"Inactive",value:false}]},
            ],
            payload: {

            },
            id: ""
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        

    }

    onChange = async (event) => {
        var payload = this.state.payload;
        payload[event.target.name] = event.target.value;
        this.setState({ payload: payload });


        this.setState({ payload: payload });
    }



    render() {
        const { breadcrumbs, label, sublabel, columns, pageLinks } = this.state;

        return (
            <>
                <Header />
                <Menu />
                <div class="content-wrap">
                    <main id="content" class="content" role="main">

                        <ol className="breadcrumb">
                            {breadcrumbs.map(data => {
                                return <li className="breadcrumb-item"><a href={(data.href != "") ? data.href : "#"}><strong>{data.label}</strong></a></li>
                            })}
                        </ol>
                        <h2 className="page-title"><span className="fw-semi-bold">{label}</span></h2>
                        <section class="widget">
                            <header>
                                <h5>
                                    <span className="fw-semi-bold">{sublabel}</span>
                                </h5>
                                <div class="widget-controls">
                                    {pageLinks.map(data => {
                                        return <a href={data.link} class="btn btn-primary mt-2 mr-3 text-white py-1 px-2" role="button">{data.label}</a>
                                    })}
                                </div>
                            </header>
                            <div class="widget-body">

                                <div class="row">
                                    <Form data={this.state} id={queryString.parse(this.props.location.search).id} />
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </main>
                </div>
                <div class="loader-wrap hiding hide">
                    <i class="fa fa-circle-o-notch fa-spin-fast"></i>
                </div>
            </>
        );
    }
}